<template>
  <div class="component-wrapper">
    <h3>Create New District</h3>
    <p v-if="msg">{{ msg }}</p>

    <div class="app-form">
      <div class="district-inputs">
        <div class="input-wrapper">
          <label for="districtAccessCode">District Access Code:</label>
          <input type="text" name="" value="" disabled v-model="districtCode">
        </div>
        <div class="input-wrapper">
          <label for="districtName">District Name: </label>
          <input type="text" id="districtName" v-model="districtName">
        </div>
        <div class="input-wrapper">
          <label for="districtCity">District City: </label>
          <input type="text" id="districtCity" v-model="districtCity">
        </div>
        <div class="input-wrapper">
          <label for="districtState">District State: </label>
          <input type="text" id="districtState" v-model="districtState">
        </div>
      </div>
      <table>
        <tr>
          <th>Unit</th>
          <th>Title</th>
          <th>Purchased</th>
        </tr>
        <tr v-for="unit in units" :key="unit.unitId">
          <td>{{unit.unitId}}</td>
          <td>{{unit.unitTitle}}</td>
          <td><input type="checkbox" :value="unit.unitId" v-model="checkedUnits"/></td>
        </tr>
      </table>
      <button type="button" @click.prevent="createDistrict">Create District</button>
      <button type="button" @click.prevent="cancelCreate">Cancel</button>
    </div>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'

export default {
  data() {
    return {
      districtCode: null,
      districtName: '',
      districtCity: '',
      districtState: '',
      units: [],
      checkedUnits: [],
      msg: null
    }
  },
  computed: {
    ...mapState([ 'userProfile' ])
  },
  methods: {
    createDistrict() {
      fb.districtsCollection.add({
        districtCode: this.districtCode,
        districtName: this.districtName,
        districtCity: this.districtCity,
        districtState: this.districtState,
        units: this.checkedUnits,
        createdBy: this.userProfile.userId,
        createdAt: new Date(),
        active: true
      }).then(() => {
        fb.districtCodesCollection.doc(this.districtCode).update({
          status: 'assigned'
        })
      }).then(() => {
        console.log(this.districtName, ' has been created!')
        this.districtCode = null
        this.districtName = ''
        this.districtCity = ''
        this.districtState = ''
        this.units = []
        this.checkedUnits = []
        this.msg = 'District was created successfully!'
      }).then(() => {
        this.cancelCreate()
      })
    },
    fetchDistrictCode() {
      fb.districtCodesCollection.where("status", "==", "available").limit(1).get().then((snap) => {
        snap.forEach((doc) => {
          console.log(doc.id)
          this.districtCode = doc.id
        })
      }).then(() => {
        fb.districtCodesCollection.doc(this.districtCode).update({
          status: 'hold'
        })
      }).catch((err) => {
        console.log('Error getting code: ', err)
      })
    },
    fetchUnits() {
      fb.unitsCollection.orderBy('orderBy').get().then((snap) => {
        snap.forEach((doc) => {
          this.units.push(doc.data())
        })
      })
    },
    cancelCreate() {
      if (this.districtCode) {
        fb.districtCodesCollection.doc(this.districtCode).update({
          status: 'available'
        }).then(() => {
          this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
        })
      } else {
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
      }
    }
  },
  mounted() {
    this.fetchDistrictCode()
    this.fetchUnits()
  }
}
</script>

<style lang="css" scoped>
.district-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 20px;
}
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
}
th, td {
  padding: 15px;
  border-bottom: 1px solid #cecece;
}
th {
  background: #0e314d;
  color: white;
  font-weight: 600;
  font-size: 1.2em
}
tr:nth-child(even) {
  background: #f7f7f7;
}
</style>
